import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { setLocale } from 'yup';

const FormikInit: React.FC = ({ children }) => {

  const [t] = useTranslation('form');

  const formatValidationNumber = (number: number): string => number.toString().replace('.', ',');

  useEffect(() => {
    setLocale({
      mixed: {
        required: t('field.required'),
        notType: t('field.not-type'),
      },
      string: {
        min: ({ min }) => t('field.min-length', { min }),
        max: ({ max }) => t('field.max-length', { max }),
        matches: t('field.matches'),
        email: t('field.email'),
      },
      number: {
        min: ({ min }) => t('field.min', { min: formatValidationNumber(min) }),
        max: ({ max }) => t('field.max', { max: formatValidationNumber(max) }),
        moreThan: ({ more }) => t('field.more', { more: formatValidationNumber(more) }),
        lessThan: ({ less }) => t('field.less', { less: formatValidationNumber(less) }),
      },
    });
  }, [t]);

  return <>{children}</>;
};

export default FormikInit;
